<div
    style=" background-color: #F3F3F5;width: 100%; height: auto; display: flex; justify-content: flex-end; padding: 0; margin: 0;">
    <button class="close-button" mat-dialog-close>
        <img src="./assets/images/close-icon.svg">
    </button>
</div>


<mat-dialog-content class="box-share-content">
    <div class="main-box-title-32" style="margin-bottom: 25px ;" >Change subscription</div>
    <div style="width: 100%;">
        <div class="main-box-title-18">Please select the new subscription for: </div>
         <div style="margin-top: 10px; margin-bottom: 10px; font-weight: 600; color: #2A3654;">
            {{ data.username }} ({{ data.email }})
            </div>
        <div class="select-container">
          <label class="alig-text">Plan</label>
          <select  name="targetPLAN" class="custom-select" [(ngModel)]="selectedPlan"
            >
            <option value="4">Organisation</option>
            <option value="1">Free</option>
            <option value="5">Organisation Plus EVP</option>
            <option value="18">Organisation Plus EVP - Yearly</option>
            <option value="3">Standard Plus EVP</option>
            <option value="16">Standard Plus EVP - Yearly</option>
            <option value="2">Standard</option>
            <option value="6">Admin</option>
          </select>
        </div>
        <div style="margin-top: 10px;"></div>
    </div>
    <div style="width: 100%;">    
        <label class="alig-text" >Extra Permissions</label>
        <div class="mobile-size">
            <mat-checkbox color="accent" [(ngModel)]="apiAccess" class="alig-text" disableRipple>API Access</mat-checkbox>
        </div>
        <div class="mobile-size">
            <mat-checkbox color="accent" [(ngModel)]="cambridgeAccess" class="alig-text" disableRipple>Access Cambridge YLE (Young Learners English)</mat-checkbox>
        </div>
        <div class="mobile-size" *ngIf="selectedPlan == '4' || selectedPlan == '5' || selectedPlan == '18'">
            <div class="detail-item">
                <label>Organisation Size</label>
                <input
                    [(ngModel)]="organization_size"  
                    class="editable-input" />
            </div>
        </div>
    </div>

    
    <div style="margin-top: 30px;"></div>
    <div class="box-button">
        <button class="cancel-btn" mat-dialog-close>
            <img class="cancel-img" src="./assets/images/yellow_icons/cancel-icon.svg">
            <span><u class="main-box-value-16-bold">Cancel</u></span>
        </button>
        <button class="analysis-button" (click)="saveChanges()" [disabled]="isSaving">
            <span class="main-box-title-16" style="font-weight: 600;">
        {{ isSaving ? 'Saving...' : 'Save Changes' }}
    </span></button>
    </div>
</mat-dialog-content>

